import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFilePerformanceConfig } from '@v2/pages/part/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsNCFilePerformanceStack = createStackNavigator();

const PartDetailsNCFilePerformanceNavigator = () => {
  return (
    <PartDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <PartDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsNCFilePerformanceStack.Navigator>
  );
};

export { PartDetailsNCFilePerformanceNavigator };
